module.exports = __webpack_public_path__ + "img/undraw_audio_player_re_cl20.01d7e83b.svg";